import { Grid } from '@mui/material'
import { useFormikContext } from 'formik'
import { t } from 'i18next'
import { AutoCompleteField } from 'src/components/shared/ui/form/fields'
import FieldsetGroup from 'src/components/shared/ui/form/fields/FieldsetGroup/FieldsetGroup'
import EntidadForm from 'src/components/views/EscritosLexnet/components/shared/components/Intervinientes/components/forms/EntidadForm'
import ProfesionalForm from 'src/components/views/EscritosLexnet/components/shared/components/Intervinientes/components/forms/ProfesionalForm'
import { FormField } from 'src/enums/Form'
import {
  useGetComunidades,
  useGetProvincias,
  useGetTipoRepresentacion
} from 'src/hooks/fetch/useCatalogoGeneralFilters'
import { RepresentanteProcesal } from 'src/interfaces/EscritosLegales'

export default function RepresentanteProcesalFormField(): JSX.Element {
  const { values, setFieldValue, validateForm } = useFormikContext<RepresentanteProcesal>()
  const representacionTipoData = useGetTipoRepresentacion(
    FormField.INTERVINIENTE_REPRESENTACION_TIPO
  )

  const comunidadAutonomaData = useGetComunidades(FormField.COMUNIDAD_AUTONOMA)
  const provinciaData = useGetProvincias(
    FormField.PROVINCIA,
    values[FormField.COMUNIDAD_AUTONOMA] || null
  )

  function handleOnChange(field: string) {
    if (field === FormField.INTERVINIENTE_REPRESENTACION_TIPO) {
      setFieldValue(FormField.ENTIDAD, null, false)
      setFieldValue(FormField.COLEGIO, null, false)
      setFieldValue(FormField.CODIGO_COLEGIADO, '', false)
      setFieldValue(FormField.INTERVINIENTE_REPRESENTANTE_PROCESAL_NIF, '', false)
      setFieldValue(FormField.INTERVINIENTE_NOMBRE, '', false)
      setFieldValue(FormField.INTERVINIENTE_PRIMER_APELLIDO, '', false)
      setFieldValue(FormField.INTERVINIENTE_SEGUNDO_APELLIDO, '', false)
      setFieldValue(FormField.INTERVINIENTE_REPRESENTANTE_PROCESAL_EMAIL, '', false)
    }
    if (field === FormField.COMUNIDAD_AUTONOMA) {
      setFieldValue(FormField.PROVINCIA, null)
      setFieldValue(FormField.COLEGIO, null, false)
    }
    if (field === FormField.PROVINCIA) {
      setFieldValue(FormField.COLEGIO, null, false)
    }
    setTimeout(() => validateForm)
  }

  return (
    <FieldsetGroup legend={t('form.legend.datos_representante_procesal')}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <AutoCompleteField
            id={FormField.INTERVINIENTE_REPRESENTACION_TIPO}
            label={t('form.field.tipo_representacion')}
            items={representacionTipoData}
            itemName="descripcion"
            onChange={handleOnChange}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <AutoCompleteField
            id={FormField.COMUNIDAD_AUTONOMA}
            label={t('form.field.comunidad')}
            items={comunidadAutonomaData}
            itemName="descripcion"
            onChange={handleOnChange}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <AutoCompleteField
            id={FormField.PROVINCIA}
            label={t('form.field.provincia')}
            items={provinciaData}
            itemName="descripcion"
            onChange={handleOnChange}
          />
        </Grid>
        <ProfesionalForm
          tipoRepresentacion={null ?? values[FormField.INTERVINIENTE_REPRESENTACION_TIPO]}
          provincia={null ?? values[FormField.PROVINCIA]}
          requiredNIF
          entidadLabel={t('form.field.colegio')}
        />
        <EntidadForm
          tipoRepresentacion={null ?? values[FormField.INTERVINIENTE_REPRESENTACION_TIPO]}
          provincia={null ?? values[FormField.PROVINCIA]}
          comunidad={null ?? values[FormField.COMUNIDAD_AUTONOMA]}
        />
      </Grid>
    </FieldsetGroup>
  )
}
